import { useUILayoutSettingsSetters, LocalLayoutSettings } from './use-ui-layout-settings-store';
import { useHelpers } from '@/composables//use-helpers';
import { LOCAL_STORAGE_KEYS } from '@/constants';

/* TODO: Combine with generic local storage settings */
export const useLocalSettings = () => {
  const setters = useUILayoutSettingsSetters();
  const { accountId } = useHelpers();

  const getLocalSettingsKey = () => {
    return `${LOCAL_STORAGE_KEYS.LAYOUT}-${accountId.value}`;
  };

  const getLocalSettings = () => {
    const DEFAULT_SERIALIZABLE = '{}';
    const serializable = localStorage.getItem(getLocalSettingsKey()) || DEFAULT_SERIALIZABLE;

    const local = JSON.parse(serializable);
    setters.updateLocalSettings(local);
  };

  const updateLocalSettings = (settings: { uiLayout: LocalLayoutSettings; }) => {
    setters.updateLocalSettings(settings);
    const serializable = JSON.stringify(settings);
    localStorage.setItem(getLocalSettingsKey(), serializable);
  };

  return { getLocalSettings, updateLocalSettings };
};
